var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticStyle: { top: "60px" },
      attrs: {
        title: "配送任务详情",
        width: 720,
        visible: _vm.visible,
        footer: null,
      },
      on: {
        cancel: function ($event) {
          _vm.visible = false
        },
      },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c("div", { staticClass: "task-info" }, [
            _c("div", { staticClass: "info-row" }, [
              _c("span", { staticClass: "label" }, [_vm._v("任务号")]),
              _c("span", [_vm._v(_vm._s(_vm.task.taskNo))]),
              _c(
                "span",
                {
                  staticClass: "label",
                  staticStyle: { "margin-left": "24px" },
                },
                [_vm._v("配送员")]
              ),
              _c("span", [_vm._v(_vm._s(_vm.task.courierName))]),
            ]),
            _c("div", { staticClass: "info-row" }, [
              _c("span", { staticClass: "label" }, [_vm._v("状态")]),
              _c("span", [_vm._v(_vm._s(_vm.task.statusName))]),
              _c(
                "span",
                {
                  staticClass: "label",
                  staticStyle: { "margin-left": "24px" },
                },
                [_vm._v("进度")]
              ),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.task.signedCount) +
                    "/" +
                    _vm._s(_vm.task.stopCount)
                ),
              ]),
            ]),
            _c("div", { staticClass: "info-row" }, [
              _c("span", { staticClass: "label" }, [_vm._v("路线方案")]),
              _c("span", [_vm._v(_vm._s(_vm.task.routeModeName))]),
            ]),
            _vm.task.routeSummary
              ? _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("方案摘要")]),
                  _c("span", [_vm._v(_vm._s(_vm.task.routeSummary))]),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "info-row share-row" },
              [
                _c("span", { staticClass: "label" }, [_vm._v("配送员链接")]),
                _c(
                  "a-input",
                  {
                    staticClass: "share-input",
                    attrs: { value: _vm.h5Link, readonly: "" },
                  },
                  [
                    _c("a-icon", {
                      staticClass: "copy-icon",
                      attrs: { slot: "suffix", type: "copy" },
                      on: { click: _vm.copyLink },
                      slot: "suffix",
                    }),
                  ],
                  1
                ),
                _c(
                  "a-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.copyLink },
                  },
                  [_vm._v("复制")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "share-tip" }, [
              _vm._v(
                "将链接发给配送员，手机浏览器打开即可查看任务并逐点签收（免登录）"
              ),
            ]),
          ]),
          _c("a-table", {
            attrs: {
              size: "small",
              bordered: "",
              rowKey: "id",
              columns: _vm.stopColumns,
              dataSource: _vm.task.stops || [],
              pagination: false,
            },
            scopedSlots: _vm._u([
              {
                key: "status",
                fn: function (text, record) {
                  return [
                    _c(
                      "a-tag",
                      {
                        attrs: {
                          color: record.status === "1" ? "green" : "orange",
                        },
                      },
                      [_vm._v(_vm._s(record.statusName))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }